(() => {
  if (customElements.get('alpha-product-rooms')) return;
  class ProductRooms extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.index = 0;
      this.request = 0;
      this.prepared = new Map();
      this.stage = this.querySelector('.apr-stage');
      this.querySelectorAll('[data-slide]').forEach((tab, i) => { tab.dataset.slide = i; });
      this.scenes = [...this.querySelectorAll('.apr-scene')];
      this.count = this.scenes.length + 1;
      this.tabs = [...this.querySelectorAll('[data-slide]')];
      this.dialog = this.querySelector('dialog');
      const zoomStyle = document.createElement('style');
      zoomStyle.textContent = '.apr-dialog .apr-dialog-navigation{display:contents!important}.apr-dialog .apr-dialog-navigation button{position:absolute!important;top:50%!important;transform:translateY(-50%);z-index:5;width:40px;height:44px;min-width:40px;padding:0;font-size:28px}.apr-dialog .apr-dialog-navigation [data-prev]{left:8px}.apr-dialog .apr-dialog-navigation [data-next]{right:8px}.apr-dialog .apr-dialog-count{position:absolute;top:18px;left:50%;transform:translateX(-50%)}';
      this.append(zoomStyle);
      this.defaultCaption = this.querySelector('.apr-caption').textContent;
      this.querySelectorAll('[data-prev]').forEach(b => b.addEventListener('click', () => this.show((this.pendingIndex ?? this.index) - 1)));
      this.querySelectorAll('[data-next]').forEach(b => b.addEventListener('click', () => this.show((this.pendingIndex ?? this.index) + 1)));
      this.tabs.forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.slide))));
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.bindSwipe(this.stage);
      this.bindSwipe(this.dialog.querySelector('.apr-dialog-content'));
      this.querySelector('.apr-expand').addEventListener('click', () => { this.updateDialog(); this.dialog.showModal(); });
      this.querySelector('.apr-close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      const root = this.closest('.dwell-art-product');
      // Return to the live painting preview only when the selected format changes.
      // show(0) also invalidates any room image still being decoded.
      const current = document.body.dataset;
      let selectedFormat = [current.artworkBrowse, current.artworkFinish, current.artworkMount || 'none'].join(':');
      window.addEventListener('alpha:artwork-browse', event => {
        if (!this.isConnected) return;
        const {type, finish, mount} = event.detail || {};
        const format = [type, finish, mount || 'none'].join(':');
        if (selectedFormat !== null && format !== selectedFormat) this.show(0);
        selectedFormat = format;
      });
      window.addEventListener('alpha:paper-border', () => {
        if (!this.isConnected) return;
        this.show(0);
        if (this.dialog.open) requestAnimationFrame(() => this.updateDialog());
      });
      root?.addEventListener('click', event => {
        const choice = event.target.closest('[data-aap-sizes] button, [data-aap-finishes] button, [data-aap-frames] button');
        if (choice && !choice.disabled && choice.getAttribute('aria-pressed') !== 'true') this.show(0);
      }, true);
      const mount = () => {
        const visuals = root?.querySelector('.aap-configurator__visuals');
        if (!visuals?.querySelector('.aap-product-preview')) return false;
        this.visuals = visuals;
        visuals.classList.add('apr-mounted');
        visuals.dataset.dwellView = 'artwork';
        visuals.append(this);
        const preview = visuals.querySelector('.aap-product-preview');
        this.bindSwipe(preview);
        preview.addEventListener('click', event => {
          if (!event.target.closest('.alpha-zoom-open')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.updateDialog();
          if (!this.dialog.open) this.dialog.showModal();
        }, true);
        if (!this.originalAdded) {
          const source = preview.querySelector('[data-aap-product-preview-image]');
          if (source) {
            this.originalAdded = true;
            const scene = document.createElement('div');
            scene.className = 'apr-scene';
            scene.hidden = true;
            scene.style.cssText = 'background:white';
            const image = document.createElement('img');
            image.src = source.currentSrc || source.src;
            image.alt = source.alt;
            image.width = source.naturalWidth || source.width;
            image.height = source.naturalHeight || source.height;
            image.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;max-width:100%;max-height:100%;object-fit:contain;transform:none;border:0;box-shadow:none';
            scene.append(image);
            this.stage.append(scene);
            this.scenes.push(scene);
            this.count = this.scenes.length + 1;
            const button = this.tabs[0].cloneNode(true);
            button.dataset.slide = this.scenes.length;
            button.setAttribute('aria-pressed', 'false');
            button.replaceChildren(image.cloneNode(true));
            button.firstElementChild.style.cssText = 'display:block;height:44px;width:auto;max-width:100%;object-fit:contain;margin:auto';
            button.setAttribute('aria-label', this.tabs[0].textContent.trim());
            button.addEventListener('click', () => this.show(Number(button.dataset.slide)));
            this.tabs[0].parentElement.append(button);
            this.tabs.push(button);
            this.querySelector('.apr-status').textContent = `1 / ${this.count}`;
          }
        }

        if (!preview.querySelector('.apr-image-nav')) {
          const nav = this.querySelector('.apr-image-nav').cloneNode(true);
          nav.querySelector('[data-prev]').addEventListener('click', event => { event.stopPropagation(); this.show((this.pendingIndex ?? this.index) - 1); });
          nav.querySelector('[data-next]').addEventListener('click', event => { event.stopPropagation(); this.show((this.pendingIndex ?? this.index) + 1); });
          preview.append(nav);
        }
        this.hidden = false;
        // Warm the first composition without competing with the main product photo.
        this.loadScene(1).catch(() => {});
        const warmRest = async () => {
          await this.loadScene(1).catch(() => {});
          for (let i = 2; i < this.count; i++) await this.loadScene(i).catch(() => {});
        };
        if ('requestIdleCallback' in window) window.requestIdleCallback(warmRest, {timeout: 1800});
        else window.setTimeout(warmRest, 900);
        return true;
      };
      if (!mount() && root) {
        this.observer = new MutationObserver(() => { if (mount()) this.observer.disconnect(); });
        this.observer.observe(root, {childList:true,subtree:true});
      }
    }
    bindSwipe(surface) {
      if (!surface || this.swipeSurfaces?.has(surface)) return;
      this.swipeSurfaces ??= new WeakSet();
      this.swipeSurfaces.add(surface);
      let start = null;
      surface.addEventListener('touchstart', event => {
        start = event.touches.length === 1 && !event.target.closest('button, a, input, select')
          ? [event.touches[0].clientX, event.touches[0].clientY] : null;
      }, {passive:true});
      surface.addEventListener('touchmove', event => {
        if (event.touches.length !== 1) start = null;
      }, {passive:true});
      surface.addEventListener('touchcancel', () => { start = null; }, {passive:true});
      surface.addEventListener('touchend', event => {
        const origin = start;
        start = null;
        if (!origin || event.touches.length || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - origin[0];
        const dy = event.changedTouches[0].clientY - origin[1];
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          this.show((this.pendingIndex ?? this.index) + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
    }
    loadScene(index, priority = 'low') {
      const scene = this.scenes[index - 1];
      if (!scene) return Promise.resolve();
      const images = [...scene.querySelectorAll('img')];
      images.forEach(image => { image.loading = 'eager'; image.fetchPriority = priority; });
      if (this.prepared.has(index)) return this.prepared.get(index);
      const ready = Promise.all(images.map(async image => {
        if (image.dataset.src) image.src = image.dataset.src;
        if (typeof image.decode === 'function') await image.decode();
        else if (!image.complete) await new Promise((resolve, reject) => {
          image.addEventListener('load', resolve, {once:true});
          image.addEventListener('error', reject, {once:true});
        });
        if (!image.naturalWidth) throw new Error('Room image unavailable');
      })).catch(error => { this.prepared.delete(index); throw error; });
      this.prepared.set(index, ready);
      return ready;
    }
    async show(index) {
      const next = (index % this.count + this.count) % this.count;
      const request = ++this.request;
      this.pendingIndex = next;
      this.querySelector('.apr-controls').setAttribute('aria-busy', 'true');
      this.tabs.forEach((tab, i) => tab.classList.toggle('apr-pending', i === next));
      try {
        // Switch only when BOTH the frame background and its painting are decoded.
        if (next > 0) await this.loadScene(next, 'high');
        if (request !== this.request) return;
        this.index = next;
        this.visuals?.classList.toggle('apr-show-room', next > 0);
        this.stage.hidden = next === 0;
        this.querySelector('.apr-caption').hidden = next === 0;
        this.querySelector('.apr-caption').textContent = this.scenes[next - 1]?.dataset?.caption || this.defaultCaption;
        this.scenes.forEach((scene, i) => { scene.hidden = i + 1 !== next; });
        this.tabs.forEach((tab, i) => tab.setAttribute('aria-pressed', String(i === next)));
        this.querySelector('.apr-status').textContent = `${next + 1} / ${this.count}`;
        if (this.dialog.open) this.updateDialog();
      } catch (_) {
        // Keep the last complete composition visible; another click can retry.
      } finally {
        if (request === this.request) {
          this.pendingIndex = null;
          this.querySelector('.apr-controls').setAttribute('aria-busy', 'false');
          this.tabs.forEach(tab => tab.classList.remove('apr-pending'));
        }
      }
    }
    updateDialog() {
      const source = this.index === 0 ? this.visuals?.querySelector('.aap-product-preview__stage') : this.scenes[this.index - 1];
      if (!source) return;
      const scene = source.cloneNode(true);
      scene.querySelectorAll('button, [id]').forEach(node => { if (node.tagName === 'BUTTON') node.remove(); else node.removeAttribute('id'); });
      scene.removeAttribute('id');
      this.dialog.querySelector('.apr-dialog-count').textContent = `${this.index + 1} / ${this.count}`;
      scene.hidden = false;
      this.dialog.querySelector('.apr-dialog-content').replaceChildren(scene);
    }
  }
  customElements.define('alpha-product-rooms', ProductRooms);
})();
